import React from 'react';
import loadable from '@loadable/component';

import withPageComponents from '../page/components/with-page-components';
import SeoMeta from '../page/components/seo-meta';
import { Helpers } from '../core/src/helpers';

const SearchSEOData = loadable(() => Helpers.retryFunc(() => import('../search-filter/components/search-seo-data')));

const mapSEOData = (seo, dynamicSEO, seralizedQuery, proxyHost) => {
    const { selfCanonical, metaLabels } = dynamicSEO || {};
    const { canonical, title, description, ...rest } = seo || {};
    const [topic] = title?.split(/ (-|\|) /) || [];
    const domainTitle = 'HP® Store';
    //if topic ends with the word "deals" deal message should just be " on" instead of " Deals on"
    const dealMessage = /deals$/i.test(topic) ? ' on' : ' Deals on';
    const showDynamicTitle = selfCanonical && metaLabels?.length > 0;
    return {
        ...rest,
        canonical: selfCanonical && seralizedQuery ? `${proxyHost ? proxyHost : ''}${seralizedQuery}` : canonical,
        title: showDynamicTitle ? `${topic?.trim()}${dealMessage} ${metaLabels.join(' ')} | ${domainTitle}` : title,
        description: showDynamicTitle
            ? `Shop the latest ${topic?.trim()}${dealMessage} ${metaLabels.join(' ')} & more at the HP® Store. Free Shipping available on qualifying purchases!`
            : description,
    };
};

export default withPageComponents(
    ({ seo, withSearch, proxyHost }) => {
        if (withSearch) {
            return (
                <SearchSEOData>
                    {({ dynamicSEO, seralizedQuery }) => {
                        return <SeoMeta seo={mapSEOData(seo, dynamicSEO, seralizedQuery, proxyHost)} />;
                    }}
                </SearchSEOData>
            );
        }

        return <SeoMeta seo={seo} />;
    },
    { seo: true, proxyHost: true },
);
